<template>
  <div
    :class="{
      'is-editable': isEditable,
    }"
  >
    <vue-file-toolbar-menu :content="menu" class="bar" v-if="isEditable"/>
    <div class="document-editor" v-if="isEditable">
      <vue-document-editor class="editor" ref="editor"
        :content="content"
        :overlay="overlay"
        :zoom="zoom"
        :page_format_mm="page_format_mm"
        :page_margins="page_margins"
        :display="display"
        :editable="isEditable"
        @changeDataContent="changeDataContent"
      />
    </div>
    <div
      v-if="!isEditable"
      class="d-flex"
    >
      <div class="form">
        <el-form
          class="form__create"
          ref="formCreate"
          :model="dataForm"
          label-width="80px"
          label-position="top"
        >
          <b-row>
            <b-col md="12">
              <el-form-item label="1. Sử dụng mẫu">
                <el-select
                  :disabled="!isEditable"
                  v-model="dataForm.dda_template_id"
                  filterable
                  clearable
                  @change="onChangeTemplate"
                >
                  <el-option
                    v-for="(item,index) in dataDefault.listTemplates"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="2. Phân loại mẫu">
                <el-select disabled v-model="dataForm.dda_category_id">
                  <el-option
                    v-for="(item,index) in dataDefault.listCategories"
                    :key="index"
                    :value="item.id"
                    :label="item.name"
                  ></el-option>
                </el-select>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="3. Tên văn bản">
                <el-input
                  disabled
                  v-model="dataForm.name"
                  type="textarea"
                  :autosize="{ minRows: 3, maxRows: 5}"
                ></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <el-form-item label="4. Số văn bản">
                <el-input disabled v-model.trim="dataForm.code"></el-input>
              </el-form-item>
            </b-col>
            <b-col md="12">
              <p class="title-note mb-1">5. Thời điểm có hiệu lực (Mặc định thời điểm hiệu lực bắt đầu từ thời điểm hoàn thành ký)</p>
              <el-form-item prop="effected_date">
                <div class="d-flex custom-label" slot="label">
                  <span>Chuyển để tự cấu hình!</span>
                  <el-switch
                    disabled
                    v-model="haveEffectedDate"
                  ></el-switch>
                </div>
                <el-date-picker
                  disabled
                  v-model="dataForm.effected_date"
                  type="date"
                  placeholder="Ngày hiệu lực"
                  :format="'dd/MM/yyyy'"
                ></el-date-picker>
              </el-form-item>
            </b-col>
          </b-row>
        </el-form>
      </div>
      <div class="preview">
        <div class="preview-content">
          <iframe
            :src="`https://docs.google.com/gview?embedded=true&url=${ExtensionService.urlImg + pdfId}`"
            width="100%"
            frameborder="0"
          ></iframe>
          <div
            class="full-screen"
            @click="showFullScreen"
          >
            <p id="test">Xem toàn màn hình</p>
          </div>
        </div>
      </div>
    </div>
    <div class="button-group mt-2">
      <div>
        <el-button
          type="info"
          plain
          @click="goBack"
          v-if="!isCreating && isEditable"
        >
          Quay lại
        </el-button>
      </div>
      <div class="">
        <el-button
          type="danger"
          plain
          @click="onCancelForm"
          v-if="isEditable"
        >
          Hủy
        </el-button>
        <el-button
          class="ml-4"
          type="primary"
          @click="goBack"
          v-if="!isEditable"
        >Đóng</el-button>
        <el-button
          class="ml-4"
          type="info"
          @click="onSaveDraff"
          v-if="isEditable"
        >Lưu nháp</el-button>
        <el-button
          class="ml-4"
          type="primary"
          @click="onCompleteDraf"
          v-if="isEditable"
        >Kết xuất văn bản</el-button>
      </div>
    </div>
    <el-dialog
      class="show-full-screen"
      :visible.sync="dialogVisibleFullScreen"
      width="100%"
      top="0"
    >
      <div class="preview-content">
        <iframe
          v-if="dialogVisibleFullScreen"
          :src="`https://docs.google.com/gview?embedded=true&url=${ExtensionService.urlImg + pdfId}`"
          width="100%"
          height="770px"
          frameborder="0"
        ></iframe>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import ExtensionService from '../../../../service/ExtensionService';
import MethodService from '../../../../service/MethodService';
import DraffDocumentAutoModel from './DraffDocumentAutoModel';
import DdaTemplateApi from "@/moduleApi/DdaTemplateApi"
import DdaCategoryApi from "@/moduleApi/DdaCategoryApi"
import ContractTemplateConfigApi from "@/moduleApi/ContractTemplateConfigApi"
import DraffDocumentAutoApi from '@/moduleApi/DraffDocumentAutoApi';
import EmployeeSignatureApi from '@/moduleApi/EmployeeSignatureApi';
import VueDocumentEditor from '@/component/VueDocumentEditor/DocumentEditor';
import VueFileToolbarMenu from 'vue-file-toolbar-menu';
import toastr from 'toastr';
export default {
  components: { VueDocumentEditor, VueFileToolbarMenu },
  data() {
    return {
      innerHeight: window.innerHeight - 150,
      ExtensionService,
      dialogVisibleFullScreen: false,
      moduleName: 'DocumentDrafting',
      pdfId: undefined,
      dataForm: MethodService.copyObject(DraffDocumentAutoModel.dataForm),
      content: [],
      contentChange: [],
      haveEffectedDate: false,
      dataDefault: {
        listCategories: [],
        listCategoriesAndCode: [],
        listParamMergeFileds: []
      },
      zoom: 1.25,
      zoom_min: 0.6,
      zoom_max: 2.3,
      isEditable: false,
      isCreating: false,
      page_format_mm: [210, 297],
      page_margins: "10mm 15mm",
      display: "grid", // ["grid", "vertical", "horizontal"]
      mounted: false, // will be true after this component is mounted
      undo_count: -1, // contains the number of times user can undo (= current position in content_history)
      content_history: [], // contains the content states for undo/redo operations
      currentUser: MethodService.getCurrentUser(),
    }
  },
  created() {
    if (this.$route.params.id) {
      this.getDataById(this.$route.params.id);
    } else {
      let data = localStorage.getItem('dataForm');
      if (data) {
        this.isEditable = true;
        this.dataForm = JSON.parse(data);
        this.content = [this.dataForm.html ?  MethodService.decodeHTML(this.dataForm.html) : ''];
        this.isCreating = true;
      }
    }
    setTimeout(() => {
      this.getAllIdFromElement()
    }, 1000 * 7);
    if (this.$router.currentRoute.name == `Admin-${this.moduleName}-detail-drafting`) {
      this.isEditable = false;
    }
    if (this.$router.currentRoute.name == `Admin-${this.moduleName}-update-drafting`) {
      this.isEditable = true;
    }
    // Initialize gesture flags
    let start_zoom_gesture = false;
    let start_dist_touch = false;
    let start_zoom_touch = false;

    // Manage ctrl+scroll zoom (or trackpad pinch)
    window.addEventListener("wheel", (e) => {
      if(e.ctrlKey){
        e.preventDefault();
        this.zoom = Math.min(Math.max(this.zoom - e.deltaY * 0.01, this.zoom_min), this.zoom_max);
      }
    }, { passive: false });

    // Manage trackpad pinch on Safari
    window.addEventListener("gesturestart", (e) => {
      e.preventDefault();
      start_zoom_gesture = this.zoom;
    });
    window.addEventListener("gesturechange", (e) => {
      e.preventDefault();
      if(!start_zoom_touch){
        this.zoom = Math.min(Math.max(start_zoom_gesture * e.scale, this.zoom_min), this.zoom_max);
      }
    });
    window.addEventListener("gestureend", () => {
      start_zoom_gesture = false;
    });

    // Manage pinch to zoom for touch devices
    window.addEventListener("touchstart", (e) => {
      if (e.touches.length == 2) {
        e.preventDefault();
        start_dist_touch = Math.hypot(
          e.touches[0].pageX - e.touches[1].pageX,
          e.touches[0].pageY - e.touches[1].pageY
        );
        start_zoom_touch = this.zoom;
      }
    }, { passive: false });
    window.addEventListener("touchmove", (e) => {
      if (start_dist_touch && start_zoom_touch) {
        e.preventDefault();
        let zoom = start_zoom_touch * Math.hypot(
          e.touches[0].pageX - e.touches[1].pageX,
          e.touches[0].pageY - e.touches[1].pageY
        ) / start_dist_touch;
        this.zoom = Math.min(Math.max(zoom, this.zoom_min), this.zoom_max);
      }
    }, { passive: false });
    window.addEventListener("touchend", () => {
      start_dist_touch = false;
      start_zoom_touch = false;
    }, { passive: false });

    // Manage history undo/redo events
    const manage_undo_redo = (e) => {
      switch(e && e.inputType){
        case "historyUndo": e.preventDefault(); e.stopPropagation(); this.undo(); break;
        case "historyRedo": e.preventDefault(); e.stopPropagation(); this.redo(); break;
      }
    }
    window.addEventListener("beforeinput", manage_undo_redo);
    window.addEventListener("input", manage_undo_redo); // in case of beforeinput event is not implemented (Firefox)

    // If your component is susceptible to be destroyed, don't forget to
    // use window.removeEventListener in the Vue.js beforeUnmount handler
  },
  mounted () { this.mounted = true; this.initData() },
  computed: {

    // This is the menu content
    menu () {
      return [

        // Undo / redo commands
        { title: "Undo", icon: "undo", disabled: !this.can_undo, hotkey: this.isMacLike ? "command+z" : "ctrl+z", click: () => this.undo() },
        { title: "Redo", icon: "redo", disabled: !this.can_redo, hotkey: this.isMacLike ? "shift+command+z" : "ctrl+y", click: () => this.redo() },

        { is: "spacer" },

        // Rich text menus
        { icon: "format_align_left", title: "Align left", active: this.isLeftAligned, disabled: !this.current_text_style, hotkey: this.isMacLike ? "shift+command+l" : "ctrl+shift+l", click: () => document.execCommand("justifyLeft") },
        { icon: "format_align_center", title: "Align center", active: this.isCentered, disabled: !this.current_text_style, hotkey: this.isMacLike ? "shift+command+e" : "ctrl+shift+e", click: () => document.execCommand("justifyCenter") },
        { icon: "format_align_right", title: "Align right", active: this.isRightAligned, disabled: !this.current_text_style, hotkey: this.isMacLike ? "shift+command+r" : "ctrl+shift+r", click: () => document.execCommand("justifyRight") },
        { icon: "format_align_justify", title: "Justify content", active: this.isJustified, disabled: !this.current_text_style, hotkey: this.isMacLike ? "shift+command+j" : "ctrl+shift+j", click: () => document.execCommand("justifyFull") },
        { is: "separator" },
        { icon: "format_bold", title: "Bold", active: this.isBold, disabled: !this.current_text_style, hotkey: this.isMacLike ? "command+b" : "ctrl+b", click: () => document.execCommand("bold") },
        { icon: "format_italic", title: "Italic", active: this.isItalic, disabled: !this.current_text_style, hotkey: this.isMacLike ? "command+i" : "ctrl+i", click: () => document.execCommand("italic") },
        { icon: "format_underline", title: "Underline", active: this.isUnderline, disabled: !this.current_text_style, hotkey: this.isMacLike ? "command+u" : "ctrl+u", click: () => document.execCommand("underline") },
        { icon: "format_strikethrough", title: "Strike through", active: this.isStrikeThrough, disabled: !this.current_text_style, click: () => document.execCommand("strikethrough") },
        { is: "button-color", type: "compact", menu_class: "align-center", disabled: !this.current_text_style, color: this.curColor, update_color: (new_color) => document.execCommand('foreColor', false, new_color.hex8) },
        { is: "separator" },
        { icon: "format_list_numbered", title: "Numbered list", active: this.isNumberedList, disabled: !this.current_text_style, click: () => document.execCommand("insertOrderedList") },
        { icon: "format_list_bulleted", title: "Bulleted list", active: this.isBulletedList, disabled: !this.current_text_style, click: () => document.execCommand("insertUnorderedList") },
        { html: "<b>H1</b>", title: "Header 1", active: this.isH1, disabled: !this.current_text_style, click: () => document.execCommand('formatBlock', false, '<h1>') },
        { html: "<b>H2</b>", title: "Header 2", active: this.isH2, disabled: !this.current_text_style, click: () => document.execCommand('formatBlock', false, '<h2>') },
        { html: "<b>H3</b>", title: "Header 3", active: this.isH3, disabled: !this.current_text_style, click: () => document.execCommand('formatBlock', false, '<h3>') },
        { icon: "format_clear", title: "Clear format", disabled: !this.current_text_style, click () { document.execCommand('removeFormat'); document.execCommand('formatBlock', false, '<div>'); } },
        { icon: "splitscreen", title: "Page break", disabled: !this.current_text_style, click: () => this.insertPageBreak() },

        { is: "spacer" },

        { // Zoom menu
          text: Math.floor(this.zoom * 100) + "%",
          title: "Zoom",
          icon: "zoom_in",
          chevron: true,
          menu: [
            ["200%", 2.0],
            ["150%", 1.5],
            ["125%", 1.25],
            ["100%", 1.0],
            ["75%", 0.75],
            ["50%", 0.5],
            ["25%", 0.25]
          ].map(([text, zoom]) => {
            return {
              text,
              active: this.zoom == zoom,
              click: () => { this.zoom = zoom; }
            }
          }),
          menu_width: 80,
          menu_height: 280,
          menu_class: "align-center"
        }
      ]
    },

    // Formats management
    current_format_name () {
      const format = this.formats.find(([, width_mm, height_mm]) => (this.page_format_mm[0] == width_mm && this.page_format_mm[1] == height_mm));
      return format ? format[0] : (this.page_format_mm[0]+"mm x "+this.page_format_mm[1]+"mm");
    },
    // formats: () => [
    //   ["A0", 841, 1189],
    //   ["A0L", 1189, 841],
    //   ["A1", 594, 841],
    //   ["A1L", 841, 594],
    //   ["A2", 420, 594],
    //   ["A2L", 594, 420],
    //   ["A3", 297, 420],
    //   ["A3L", 420, 297],
    //   ["A4", 210, 297],
    //   ["A4L", 297, 210],
    //   ["A5", 148, 210],
    //   ["A5L", 210, 148],
    //   ["A6", 105, 148],
    //   ["A6L", 148, 105]
    // ],

    // Margins management
    // current_margins_name () {
    //   const margins = this.margins.find(([, margins]) => (this.page_margins == margins));
    //   return margins ? margins[0] : margins[1];
    // },
    // margins: () => [
    //   ["Medium", "20mm"],
    //   ["Small", "15mm"],
    //   ["Slim", "10mm 15mm"],
    //   ["Tiny", "5mm"]
    // ],

    // Current text style management
    current_text_style () { return this.mounted ? this.$refs.editor.current_text_style : false; },
    isLeftAligned () { return ["start", "left", "-moz-left"].includes(this.current_text_style.textAlign); },
    isRightAligned () { return ["end", "right", "-moz-right"].includes(this.current_text_style.textAlign); },
    isCentered () { return ["center", "-moz-center"].includes(this.current_text_style.textAlign); },
    isJustified () { return ["justify", "justify-all"].includes(this.current_text_style.textAlign); },
    isBold () {
      const fontWeight = this.current_text_style.fontWeight;
      return fontWeight && (parseInt(fontWeight) > 400 || fontWeight.indexOf("bold") == 0);
    },
    isItalic () { return this.current_text_style.fontStyle == "italic"; },
    isUnderline () { // text-decoration is not overridden by children, so we query the parent stack
      const stack = this.current_text_style.textDecorationStack;
      return stack && stack.some(d => (d.indexOf("underline") == 0));
    },
    isStrikeThrough () { // text-decoration is not overridden by children, so we query the parent stack
      const stack = this.current_text_style.textDecorationStack;
      return stack && stack.some(d => (d.indexOf("line-through") == 0));
    },
    isNumberedList () { return this.current_text_style.isList && this.current_text_style.listStyleType == "decimal"; },
    isBulletedList () { return this.current_text_style.isList && ["disc", "circle"].includes(this.current_text_style.listStyleType); },
    isH1 () { return this.current_text_style.headerLevel == 1; },
    isH2 () { return this.current_text_style.headerLevel == 2; },
    isH3 () { return this.current_text_style.headerLevel == 3; },
    curColor () { return this.current_text_style.color || "transparent"; },

    // Platform management
    isMacLike: () => /(Mac|iPhone|iPod|iPad)/i.test(navigator.platform),

    // Undo / redo flags
    can_undo () { return this.undo_count > 0; },
    can_redo () { return this.content_history.length - this.undo_count - 1 > 0; }
  },
  methods: {
    showFullScreen() {
      this.dialogVisibleFullScreen = true
    },
    getAllIdFromElement() {
      let arrIds = [];
      $("*").each(function() {
        if (this.id) {
          arrIds.push(this.id);
        }
      });
      let arrDulicate = MethodService.findDuplicates(arrIds);
      (arrDulicate || []).forEach(item => {
        let elements = document.querySelectorAll(`#${item}`);
        elements.forEach((element,index) => {
          if (index == 0) return;
          element.style.textIndent = "0";
        });
      })

    },
    async getDataById(id) {
      const apiRes = await DraffDocumentAutoApi.findById(id);
      if (apiRes.result) {
        this.dataForm = apiRes.result;
        if (this.dataForm.unsigned_pdf_id || this.dataForm.signed_pdf_id) {
          this.pdfId = this.dataForm.signed_pdf_id ? this.dataForm.signed_pdf_id : this.dataForm.unsigned_pdf_id;
        } else {
          const resApi = await DraffDocumentAutoApi.ViewDraffPdf({
            dda_id: id
          })
          console.log('resApi.result', resApi.result)
          this.pdfId = resApi.result.fileId
        }
        this.content = [apiRes.result.html ?  MethodService.decodeHTML(apiRes.result.html) : ''];
        let checkInside = (this.dataForm.readers || []).find(item => item.employee_id == this.currentUser.id)
        if (!checkInside) {
          if (!this.dataForm.readers) this.dataForm.readers = []
          this.dataForm.readers.push({
            employee_id: this.currentUser.id,
            read_at: new Date()
          })
          this.updateReaders(this.dataForm)
        }
      }
    },
    updateReaders(dataForm) {
      try {
        DraffDocumentAutoApi.update(dataForm)
      } catch (error) {
        toastr.error('Có lỗi xảy ra, vui lòng thử lại!')
      }
    },
    async initData() {
      this.dataDefault.listCategoriesAndCode = []
      let ddaTemplateApiRes
      let contractTemplateApiRes
      let ddaCategoryApiRes
      let resParamMergeFields
      [ddaTemplateApiRes, contractTemplateApiRes, ddaCategoryApiRes, resParamMergeFields] = await Promise.all([
        DdaTemplateApi.list({
          limit: 1000,
          fields: 'id,name,dda_category_id,content'
        }),
        ContractTemplateConfigApi.list({
          limit: 1000
        }),
        DdaCategoryApi.list({
          limit: 100,
          fields: 'id,name,code'
        }),
        DdaTemplateApi.GetParamValuesForContractTemplate()
      ])
      this.dataDefault.listTemplates = [
        ...(ddaTemplateApiRes.result || []),
        ...(contractTemplateApiRes.result || [])
      ]
      this.dataDefault.listCategories = ddaCategoryApiRes.result
      this.dataDefault.listParamMergeFileds = resParamMergeFields.result
    },
    async onCancelForm() {
      localStorage.removeItem('dataForm');
      setTimeout(() => {
        this.$router.go(-2)
      }, 200);
    },
    async onChangeTemplate(id) {
      if (!id) return;
      const template = this.dataDefault.listTemplates.find(item => item.id === id);
      if (template) {
        this.dataForm.dda_category_id = template.dda_category_id;
        const header = template.content && template.content.header ? template.content.header : "";
        const body = template.content && template.content.body ? template.content.body : "";
        const footer = template.content && template.content.footer ? template.content.footer : "";
        
        const fullContent = MethodService.mergeField(
          MethodService.decodeHTML(header + body + footer),
          {
            ...this.dataDefault.listParamMergeFileds,
            "{{@SoVanBan}}": this.dataForm.code || ""
          }
        );
        this.content = [fullContent];
        this.$forceUpdate();
      }
    },
    goBack(){
      if (this.isEditable) {
        this.$router.go(-1)
      } else {
        this.$router.go(-2)
      }
    },
    async onSaveDraff(){
      //Cập nhật trạng thái là DRAFF và cập nhaarh field "html" mới
      let data = MethodService.copyObject(this.dataForm);
      data.html = this.contentChange[0] ? this.contentChange[0] : this.content[0];
      data.status = "DRAFF";

      let res;
      if (this.isCreating) {
        res = await DraffDocumentAutoApi.create(data);
      } else {
        res = await DraffDocumentAutoApi.update(data);
      }
      // const res = await DraffDocumentAutoApi.create(data);
      if (res.result) {
        localStorage.removeItem('dataForm');
        toastr.success('Lưu nháp thành công');
        this.$router.push({name: 'Admin-DocumentDrafting-list'}).catch((err) => {});
      } else {
        toastr.error('Lưu nháp thất bại');
      }
    },
    async onCompleteDraf(){
      //Gọi Api generate PDF và lưu vào DB
      let data = MethodService.copyObject(this.dataForm);
      data.html = this.contentChange[0] ? this.contentChange[0] : this.content[0];
      data.status = "COMPLETED";

      let res;
      if (this.isCreating) {
        res = await DraffDocumentAutoApi.create(data);
      } else {
        res = await DraffDocumentAutoApi.update(data);
      }

      if (res.result) {
        try {
          toastr.success('Tạo văn bản thành công');
          EmployeeSignatureApi.ExportHtmlToPdf(res.result);
          localStorage.removeItem('dataForm');
          this.$router.push({name: 'Admin-DocumentDrafting-list'}).catch((err) => {});
        } catch (error) {
        if (error.detail) {
            toastr.error(error.detail);
          } else {
            toastr.error('Kết xuất văn bản lỗi');
          }
        }
      } else {
        toastr.error('Tạo văn bản thất bại');
      }
    },
    changeDataContent(dataContent) {
      this.contentChange = dataContent;
    },
    // Page overlays (headers, footers, page numbers)
    overlay (page, total) {
      // Add page numbers on each page
      let html = '<div style="position: absolute; bottom: 8mm; ' + ((page % 2) ? 'right' : 'left') + ': 10mm">Page ' + page + ' of ' + total + '</div>';

      // Add custom headers and footers from page 3
      if(page >= 3) {
        html += '<div style="position: absolute; left: 0; top: 0; right: 0; padding: 3mm 5mm; background: rgba(200, 220, 240, 0.5)"><strong>MYCOMPANY</strong> example.com /// This is a custom header overlay</div>';
        html += '<div style="position: absolute; left: 10mm; right: 10mm; bottom: 5mm; text-align:center; font-size:10pt">MY COMPANY - example.com /// This is a custom footer overlay</div>';
      }
      return html;
    },

    // Undo / redo functions examples
    undo () { if(this.can_undo){ this._mute_next_content_watcher = true; this.content = this.content_history[--this.undo_count]; } },
    redo () { if(this.can_redo){ this._mute_next_content_watcher = true; this.content = this.content_history[++this.undo_count]; } },
    resetContentHistory () { this.content_history = []; this.undo_count = -1; },

    // Insert page break function example
    async insertPageBreak () {
      // insert paragraph at caret position
      document.execCommand("insertParagraph");

      // insert a marker at caret position (start of the new paragraph)
      const marker = "###PB###"; // must be regex compatible
      document.execCommand("insertText", false, marker);

      // wait for v-model content update (two ticks are needed to reactivate watch on content)
      // await this.$nextTick();
      // await this.$nextTick();

      // find the marker inside content items and split this content item in two items between the two paragraphs
      // only match root tags (p, div, h1, h2...) to avoid non-root tags like <li>
      const regexp = new RegExp("<(p|div|h\\d)( [^/>]+)*>(<[^/>]+>)*"+marker);
      for(let i = 0; i < this.content.length; i++) {
        const item = this.content[i];
        if(typeof item != "string") continue;
        const match = regexp.exec(item);
        if(match) {
          const tags_open = match[0].slice(0, -marker.length);
          let content_plus_tags_close = item.substr(match.index + match[0].length);
          // insert <br> to empty pages that would not be handled correctly by contenteditable
          if(content_plus_tags_close.indexOf("</") == 0) content_plus_tags_close = "<br>" + content_plus_tags_close;
          this.content.splice(i, 1, item.substr(0, match.index), tags_open + content_plus_tags_close);
          return;
        }
      }

      // if the code didn't return before, the split didn't work (e.g. inside a <li>). just remove the marker from the content
      for(let i = 0; i < this.content.length; i++) {
        const item = this.content[i];
        if(typeof item != "string" || item.indexOf(marker) < 0) continue;
        this.content.splice(i, 1, item.replace(marker, ''));
        break;
      }
    }
  },
}
</script>
<style lang="scss" scoped>
.bar {
  padding-top: 5px;
  padding-bottom: 5px;
  padding-left: 40px;
  padding-right: 40px;
  background: #fff;
}
.document-editor {
  height: calc(100vh - 150px);
  overflow: auto;
  .editor {
    background: #D0D5D9;
  }
}
.is-editable .document-editor {
  height: calc(100vh - 190px);
  overflow: auto;
}
.detail-document {
  iframe {
    height: calc(100vh - 155px);
  }
}
.button-group {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  justify-content: space-between;
}
.form {
  width: 620px;
  padding: 5px;
  background: #fff;
  margin-right: 25px;
  height: calc(100vh - 145px);
  .form__create {
    height: calc(100vh - 155px);
    overflow-y: auto;
    padding: 10px;
    border: 1px solid #7E7E7E;
    // .col-md-12 {
    //   padding-left: 0;
    // }
  }
}
.preview {
  width: 100%;
  background: #fff;
  position: relative;
  .preview-title {
    font-size: 15px;
  }
  .preview-content {
    box-shadow: 0px -2px 2px rgba(0, 0, 0, 0.15), 0px 4px 4px rgba(0, 0, 0, 0.25);
    border-radius: 5px;
    height: calc(100vh - 145px);
    overflow: auto;
    iframe {
      height: 99%;
    }
    .editor {
      background: #D0D5D9;
    }
  }
  .full-screen {
    position: absolute;
    bottom: 0;
    width: 100%;
    text-align: center;
    height: 50px;
    background: #292D32;
    opacity: 0.8;
    display: flex;
    justify-content: center;
    align-items: center;
    &:hover {
      cursor: pointer;
    }
    p {
      color: #fff;
      font-weight: 400;
      font-size: 18px;
      line-height: 28px;
    }
  }
}
::v-deep .custom-label {
  width: 390px;
  align-items: center;
  justify-content: space-between;
  .el-switch {
    .el-switch__core {
      border-radius: 10px;
      &:after {
        border-radius: 10px;
      }
    }
  }
}
::v-deep .show-full-screen {
  .el-dialog {
    margin-bottom: 0;
    border-radius: 0;
    .el-dialog__header {
      padding: 0 !important;
    }
    .el-dialog__body {
      max-height: calc(100vh - 2px);
      overflow: auto;
      .preview-content {
        .editor {
          background: #D0D5D9;
        }
        iframe {
          height: calc(100vh - 47px);
        }
      }
    }
  }
}
@media (max-height: 600px) {
  .preview {
    .preview-content {
      iframe {
        height: 98%;
      }
    }
  }
}
@media (max-height: 380px) {
  .preview {
    .preview-content {
      iframe {
        height: 95%;
      }
    }
  }
}
</style>
